import { controlToastState } from "risa-oasis-ui_v2";
import { getCmmInputDataForOrder } from "../../../api/bigQuery/nycbsPharmaOrders";
import { mapToCoverMyMedsInputModel } from "../../../data-model/cmmInputRequestModel";
import { sendToPlanPrimaryCare } from "../apis/sendToPlanPrimaryCare";

interface OnSendToPlanConfirmParams {
  identifier: string;
  email?: string;
  onSuccess?: () => void;
  onError?: () => void;
}

export const onSendToPlanConfirm = async (
  signal: AbortSignal,
  params: OnSendToPlanConfirmParams,
): Promise<boolean> => {
  const { identifier, email, onSuccess, onError } = params;

  try {
    // Fetch complete order data
    const orderDataResponse = await getCmmInputDataForOrder(identifier);

    if (!orderDataResponse || !orderDataResponse.details) {
      controlToastState("send-to-plan-failure");
      onError?.();
      return false;
    }

    // Map the complete order data to CoverMyMeds format
    const completePayload = mapToCoverMyMedsInputModel(
      orderDataResponse.details,
    );

    // Send to plan with complete payload
    await sendToPlanPrimaryCare(signal, completePayload, identifier, email);
    onSuccess?.();
    return true;
  } catch (error) {
    console.error("Error in onSendToPlanConfirm:", error);
    controlToastState("send-to-plan-failure");
    onError?.();
    return false;
  }
};
